import '../../App.css';
import placeholderImage from '../../assets/product-placeholder.png'; // Import the placeholder image

function Product({ item, handleEdit, handleDelete, showEdit = true, showDelete = true }) {
    return (
        <div key={item?.id || 'default-id'} className="product-card" style={{ position: "relative", padding: "20px", border: "1px solid #ddd", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}>
            {item?.isDraft && (
                <div
                    style={{
                        position: "absolute",
                        top: "10px",
                        left: "20px",
                        backgroundColor: "#ffcc00",
                        color: "#000",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        fontWeight: "bold",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                        zIndex: 2147483647, // Set to maximum value
                    }}
                >
                    Draft
                </div>
            )}
            <div style={{ position: "relative", width: "100%", marginBottom: "0.8em" }}>
                <img
                    src={item?.image?.path || item?.src || placeholderImage} // Use the imported placeholder image
                    alt={item.title}
                    style={{
                        width: "100%", // Fill the container width
                        height: "200px", // Fixed height to maintain consistent card sizes
                        objectFit: "contain", // Show the whole image without cropping, may have empty space
                        borderRadius: "4px", // Optional: Keep the rounded corners
                        marginBottom: "0",
                    }}
                />
                {item?.isPromotion && item?.quantity !== 0 && (
                    <div
                        style={{
                            position: "absolute",
                            top: "10px",
                            right: "2px",
                            background: "linear-gradient(135deg, #ff6b35, #f7931e)",
                            color: "white",
                            padding: "8px 12px",
                            borderRadius: "20px",
                            fontSize: "14px", // Fixed pixel size to ensure consistency
                            fontWeight: "bold",
                            boxShadow: "0 4px 12px rgba(255, 107, 53, 0.4)",
                            zIndex: 10,
                            transform: "rotate(-5deg)",
                            border: "2px solid rgba(255, 255, 255, 0.9)",
                            letterSpacing: "0.5px",
                            textShadow: "1px 1px 2px rgba(0, 0, 0, 0.3)",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            animation: "promotionGlow 2s ease-in-out infinite alternate",
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.transform = "rotate(-5deg) scale(1.1)";
                            e.target.style.boxShadow = "0 6px 20px rgba(255, 107, 53, 0.6)";
                            e.target.style.animation = "promotionPulse 0.6s ease-in-out infinite alternate";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = "rotate(-5deg) scale(1)";
                            e.target.style.boxShadow = "0 4px 12px rgba(255, 107, 53, 0.4)";
                            e.target.style.animation = "promotionGlow 2s ease-in-out infinite alternate";
                        }}
                    >
                        <style>
                            {`
                                @keyframes promotionGlow {
                                    0% { 
                                        box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
                                    }
                                    100% { 
                                        box-shadow: 0 6px 20px rgba(255, 107, 53, 0.7);
                                    }
                                }
                                @keyframes promotionPulse {
                                    0% { 
                                        transform: rotate(-5deg) scale(1.1);
                                    }
                                    100% { 
                                        transform: rotate(-5deg) scale(1.15);
                                    }
                                }
                            `}
                        </style>
                        {item?.promotionValue ? (
                            <>
                                🔥 {item.promotionValue}% OFF
                            </>
                        ) : (
                            <>
                                🔥 SALE
                            </>
                        )}
                    </div>
                )}
                {item?.quantity === 0 && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(128, 128, 128, 0.7)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "4px",
                            zIndex: 20,
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: "rgba(220, 53, 69, 0.9)",
                                color: "white",
                                padding: "10px 20px",
                                borderRadius: "8px",
                                fontSize: "18px",
                                fontWeight: "bold",
                                textAlign: "center",
                                border: "2px solid rgba(255, 255, 255, 0.8)",
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
                                letterSpacing: "1px",
                            }}
                        >
                            SOLD OUT
                        </div>
                    </div>
                )}
            </div>
            <h3 style={{ fontSize: "16px", margin: "10px 0 5px 0" }}>
                {item?.title || 'No title available'}
            </h3>
            <p style={{ fontSize: "14px", margin: "0 0 10px 0" }}>
                {item?.text || 'No description available'}
            </p>
            <p style={{ fontSize: "14px", margin: "0" }}>
                <strong>Price:</strong> ${item?.price || '0.00'}
            </p>
            <div>
                {showEdit && <button
                    className="edit-button"
                    onClick={() => handleEdit(item?.id)}
                    style={{
                        backgroundColor: item?.isEdit ? '#ccc' : '#007bff', // Gray background when disabled
                        color: item?.isEdit ? '#666' : '#fff', // Lighter text color when disabled
                        cursor: item?.isEdit ? 'not-allowed' : 'pointer', // Show "not-allowed" cursor when disabled
                        border: item?.isEdit ? 'none' : '1px solid #007bff', // Remove border when disabled
                    }}
                >
                    Edit
                </button>}
                {showDelete && <button
                    className="delete-button"
                    onClick={() => handleDelete(item?.id)}
                    style={{
                        backgroundColor: "#dc3545",
                        color: "#fff",
                        border: "1px solid #dc3545",
                        cursor: "pointer",
                        marginLeft: "10px",
                    }}
                >
                    Delete
                </button>}
            </div>
        </div>
    );
}

export default Product;